<template>
    <div class="login-layout">
        <section class="login-panel">
            <div class="login-panel-content">
                <div class="login-header">
                    <img src="../assets/AiNurse.png" class="login-logo" alt="Logo AiNurse">
                    <p class="login-welcome">Acesse sua conta para continuar</p>
                </div>

                <form class="login-form" @submit.prevent="signin">
                    <div class="input-group">
                        <span class="input-icon mdi mdi-email" aria-hidden="true"></span>
                        <input
                            id="email"
                            v-model="user.email"
                            class="login-input"
                            type="email"
                            name="email"
                            placeholder=" "
                            autocomplete="username"
                            required
                            aria-label="E-mail de login"
                        >
                        <label class="floating-label" for="email">E-mail</label>
                    </div>

                    <div class="input-group">
                        <span class="input-icon mdi mdi-lock" aria-hidden="true"></span>
                        <input
                            id="password"
                            v-model="user.password"
                            class="login-input with-toggle"
                            :type="show1 ? 'text' : 'password'"
                            name="password"
                            placeholder=" "
                            autocomplete="current-password"
                            required
                            aria-label="Senha de login"
                            @keydown.enter="signin"
                        >
                        <label class="floating-label" for="password">Senha</label>
                        <button
                            type="button"
                            class="toggle-password mdi"
                            :class="show1 ? 'mdi-eye-off' : 'mdi-eye'"
                            aria-label="Mostrar ou ocultar senha"
                            @click="show1 = !show1"
                        ></button>
                    </div>

                    <button
                        v-if="!usuarioLogado"
                        class="login-button"
                        type="submit"
                        :disabled="loading"
                        aria-label="Entrar no sistema"
                    >
                        <span v-if="loading" class="login-spinner" aria-hidden="true"></span>
                        {{ loading ? "ACESSANDO..." : "ACESSAR" }}
                    </button>
                </form>

                <div class="footer-area">
                    <p class="copyright-text">Todos os direitos reservados Intelite Tecnologia ® {{ new Date().getFullYear() }}</p>
                </div>
            </div>
        </section>

        <aside class="banner-panel" aria-hidden="true">
            <div class="banner-overlay"></div>
            <div class="banner-content">
                <span class="banner-eyebrow">AiNurse · Intelite</span>
                <h2 class="banner-title">Chamada de enfermagem inteligente</h2>
                <p class="banner-sub">Atendimento mais rápido e registro auditável de cada chamada — direto no posto de enfermagem.</p>
                <ul class="banner-list">
                    <li><span class="mdi mdi-check-circle"></span> Chamados em tempo real</li>
                    <li><span class="mdi mdi-check-circle"></span> Histórico pronto para auditoria</li>
                    <li><span class="mdi mdi-check-circle"></span> Painéis personalizáveis por unidade</li>
                </ul>
            </div>
        </aside>

        <Snackbar ref="chamaSnackbar" />
    </div>
</template>

<script>
    import { userKey, baseApiUrl } from '@/global'
    import Snackbar from '../componentes/snackbar.vue'
    import { mapState } from 'vuex'
    import axios from 'axios'
    export default {
        components: {Snackbar},
        name: 'Auth',
        computed: mapState({
            usuarioLogado: state => state.isMenuVisible,
        }),
        data: function() {
            return {
                loading: false,
                countAccess: '',
                userObj: [],
                show1: false,
                token: "",
                userId: "",
                showSignup: false,
                showAlterPass: false,
                userPemission: "",
                user: {},
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+/.test(v) || 'E-mail não é válido'
                ],
                nameRules: [
                    v => !!v || 'Nome é obrigatório'
                ],
                passwordRules: [
                    v => !!v || 'Senha é obrigatório'
                ]
            }
        },

        mounted: function () {
            if (sessionStorage.getItem('accToken') != null) {
                if (sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).ativo == true) {
                    if (JSON.parse(sessionStorage.getItem('user')).tipo == 'GERENTE' || JSON.parse(sessionStorage.getItem('user')).tipo == 'ADMIN') {
                        this.$router.push({ path: '/home' })
                    } else if (JSON.parse(sessionStorage.getItem('user')).tipo == 'ENFERMAGEM') {
                        this.$router.push({ path: '/painel' })
                    }
                } else {
                    this.$router.push({ path: '/home' })
                }
            }
            if (sessionStorage.getItem('userPermission') != null)
                this.$store.dispatch('Permission')
            if (sessionStorage.getItem('accToken') != null)
                this.$store.dispatch('Logar', this.token)
        },

        methods: {
            async signin() {
                this.loading = true
                if ((this.user.email != null) || (this.user.password != null)) {
                    await axios.post(baseApiUrl + 'Usuarios/login', this.user)
                    .then(response => {
                        this.token = response.data.id
                        this.userId = response.data.userId
                        this.verificaUsuario()
                    })
                    .catch(() => {
                        this.loading = false
                        var vm = this;
                        vm.$refs.chamaSnackbar.snack("#EF5350","Usuário e senha inválidos. Corrija e tente novamente!","ERRO")
                    })
                } else {
                    this.loading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Preencha os campos de E-mail e Senha!","ATENÇÃO")
                }
            },

            Sair() {
                this.$store.dispatch('Sair')
            },

            async verificaUsuario() {
                if (this.userId != '') {
                    await axios.get(baseApiUrl + 'Usuarios/' + this.userId + '?access_token=' + this.token)
                    .then(res => {
                        sessionStorage.setItem('accToken', this.token)
                        this.userPemission = res.data.tipo
                        this.user.username = res.data.nome
                        this.userObj = res.data
                        sessionStorage.setItem(userKey, JSON.stringify(this.userPemission))
                        sessionStorage.setItem('userPermission', this.userPemission)
                        sessionStorage.setItem('userName', this.user.username)
                        sessionStorage.setItem('user', JSON.stringify(res.data))
                        this.$store.dispatch('SetUser')
                        this.$store.dispatch('Permission')
                        this.$store.dispatch('SetUserName')
                        this.$store.dispatch('Logar', this.token)
                        this.verificaCompany()
                        if (res.data.tipo === "GERENTE" || res.data.tipo === "ADMIN" && res.data.ativo === true) {
                            this.$router.push({ path: '/home' })
                        } else if (res.data.tipo === "ENFERMAGEM" && res.data.ativo === true) {
                            this.$router.push({ path: '/painel' })
                        } else {
                            sessionStorage.clear()
                            this.loading = false
                            var vm = this;
                            vm.$refs.chamaSnackbar.snack("#F9A825","Usuário inativo ou sem permissão de acesso!", "ATENÇÃO")
                        }
                    })
                    .catch(() => {
                        //
                    })
                }
            },

            verificaCompany() {
                axios.get(baseApiUrl + 'Empresas/' + this.userObj.empresaId)
                .then(response => {
                    sessionStorage.setItem('company', JSON.stringify(response.data))
                    this.$store.dispatch('SetCompany')
                    this.loading = false
                })
                .catch(() => {
                    this.loading = false
                    var vm = this
                    vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao consultar empresa", "DESCULPE")
                })
            },
        }
    }
</script>

<style>
    .login-layout {
        min-height: 100vh;
        display: flex;
        background-color: #ffffff;
    }

    .login-panel {
        width: 100%;
        max-width: 481px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 42px 38px;
        position: relative;
        z-index: 2;
    }

    .login-panel-content {
        width: 100%;
        max-width: 330px;
    }

    .login-header {
        text-align: center;
        margin-bottom: 26px;
    }

    .login-logo {
        width: 220px;
        max-width: 100%;
        margin-bottom: 6px;
    }

    .login-welcome {
        margin: 0;
        font-size: 13px;
        color: #8b93a3;
    }

    .login-form {
        width: 100%;
    }

    .input-group {
        position: relative;
        margin-bottom: 16px;
    }

    .input-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #7f8798;
        font-size: 16px;
        pointer-events: none;
    }

    .login-input {
        width: 100%;
        height: 48px;
        border: 1px solid #c7cfdf;
        border-radius: 8px;
        padding: 0 12px 0 38px;
        font-size: 14px;
        color: #2a3347;
        background: #f7f9fc;
        outline: none;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .login-input:focus {
        border-color: #038b8b;
        box-shadow: 0 0 0 3px rgba(3, 139, 139, 0.15);
    }

    .floating-label {
        position: absolute;
        left: 34px;
        top: 50%;
        transform: translateY(-50%);
        color: #8b93a3;
        font-size: 13px;
        line-height: 1;
        padding: 0 4px;
        background: #f7f9fc;
        pointer-events: none;
        transition: all 0.18s ease;
    }

    .login-input:focus + .floating-label,
    .login-input:not(:placeholder-shown) + .floating-label {
        top: 0;
        transform: translateY(-50%);
        font-size: 11px;
        color: #038b8b;
        background: #fff;
    }

    .with-toggle {
        padding-right: 40px;
    }

    .toggle-password {
        position: absolute;
        right: 11px;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        color: #7f8798;
        font-size: 18px;
        cursor: pointer;
        padding: 0;
    }

    .login-button {
        width: 100%;
        height: 48px;
        margin-top: 12px;
        border: none;
        border-radius: 10px;
        background: linear-gradient(135deg, #026a6a, #038b8b);
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0.6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        box-shadow: 0 8px 20px rgba(3, 139, 139, 0.28);
        transition: filter 0.2s ease, transform 0.15s ease;
    }

    .login-button:hover {
        filter: brightness(1.05);
        transform: translateY(-1px);
    }

    .login-button:disabled {
        opacity: 0.8;
        cursor: not-allowed;
        transform: none;
    }

    .login-spinner {
        width: 16px;
        height: 16px;
        border: 2px solid rgba(255, 255, 255, 0.4);
        border-top-color: #fff;
        border-radius: 50%;
        animation: loginSpin 0.7s linear infinite;
    }

    @keyframes loginSpin {
        to { transform: rotate(360deg); }
    }

    .footer-area {
        display: flex;
        justify-content: center;
        margin-top: 18px;
    }

    .copyright-text {
        margin: 0;
        font-size: 11px;
        color: #75829a;
        white-space: nowrap;
    }

    /* ===== Banner lateral ===== */
    .banner-panel {
        flex: 1;
        position: relative;
        background-image: url("../assets/background.png");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        overflow: hidden;
    }

    .banner-overlay {
        position: absolute;
        inset: 0;
        background: linear-gradient(125deg, rgba(15, 15, 65, 0.92) 0%, rgba(15, 15, 65, 0.78) 45%, rgba(3, 139, 139, 0.62) 100%);
    }

    .banner-content {
        position: relative;
        z-index: 1;
        max-width: 460px;
        padding: 0 8% ;
        color: #fff;
    }

    .banner-eyebrow {
        display: inline-block;
        font-size: 0.78rem;
        font-weight: 700;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: #8fe3e3;
        margin-bottom: 16px;
    }

    .banner-title {
        font-size: 2.1rem;
        font-weight: 800;
        line-height: 1.15;
        margin: 0 0 14px;
    }

    .banner-sub {
        font-size: 1.02rem;
        color: rgba(255, 255, 255, 0.88);
        margin: 0 0 26px;
    }

    .banner-list {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .banner-list li {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 0.98rem;
        font-weight: 600;
        margin-bottom: 12px;
    }

    .banner-list .mdi {
        color: #5ee0c0;
        font-size: 20px;
    }

    .login-button:focus {
        outline: 2px solid #5ec4c4;
        outline-offset: 2px;
    }

    @media (max-width: 1024px) {
        .login-panel {
            max-width: 100%;
        }

        .banner-panel {
            display: none;
        }
    }
</style>
